import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37dfd6fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=37dfd6fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dfd6fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37dfd6fc')) {
      api.createRecord('37dfd6fc', component.options)
    } else {
      api.reload('37dfd6fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=37dfd6fc&scoped=true", function () {
      api.rerender('37dfd6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/index.vue"
export default component.exports